/**
 * GHL OAuth handshake hooks shared by the 4 near-duplicate integration pages
 * (src/integration/{auth,account_auth} and src/appIntegration/{auth,account_auth}).
 * All imperative (fired from useEffect chains reacting to an OAuth redirect's
 * query params), not render-triggered reads — modeled as useMutation, not
 * useQuery. See src/queries/webhooks.js for the template this follows.
 */
import { useMutation } from "@tanstack/react-query";
import { request, ReqMethods } from "../lib/apiClient";

const { POST, PUT } = ReqMethods;

// POST /services/ghl/ — our backend proxying a request to GHL server-side;
// `payload` is {method, path, headers, payload} describing the outbound GHL
// call, not a direct third-party browser call. Used for both the token
// exchange (getCreds) and the location lookup (getLocation) across all 4
// call sites.
export function useGhlProxyCall() {
  return useMutation({
    mutationFn: (payload) => request(POST, "/services/ghl/", { payload }),
  });
}

// PUT /brand — src/integration/auth/index.js's associate() only.
export function useUpdateBrand() {
  return useMutation({
    mutationFn: (payload) => request(PUT, "/brand", { payload }),
  });
}

// PUT /accounts — associate() in the other 3 near-duplicate GHL pages
// (src/integration/account_auth, src/appIntegration/{auth,account_auth}),
// also reused by add-payment/index.jsx's free-SaaS auto-provision step.
export function useUpdateAccount() {
  return useMutation({
    mutationFn: (payload) => request(PUT, "/accounts", { payload }),
  });
}
